export const BASE_URL =
  "https://us-central1-singhal-consultancy.cloudfunctions.net/app";
